import { render } from "./ImagePropsCmp.vue?vue&type=template&id=13d628d8"
import script from "./ImagePropsCmp.vue?vue&type=script&lang=js"
export * from "./ImagePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__